import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import SelectRegion from "./SelectRegion";
export default function LoggedOut() {
    return (_jsx(_Fragment, { children: _jsx(SelectRegion, {}) }));
}
